import React from 'react';

import './Footer.scss';

class Footer extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    return (
      <div className="RLX-Footer">
        <p>
          Rock Lititz IP and Site content &copy; 2017-2022 Rock Lititz
          {/*<br />
          RLX Editor design and application &copy; 2017-2019 Austin Billings*/}
        </p>
      </div>
    );
  }
};

export default Footer;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Footer/Footer.jsx